import { money } from "../lib/api";

export const splitPlan = (total, n) => {
  const cents = Math.round(total * 100);
  const base = Math.floor(cents / n);
  return Array.from({ length: n }, (_, i) => (base + (i === 0 ? cents - base * n : 0)) / 100);
};

const OPTIONS = [1, 2, 3, 4];

export const PlanPicker = ({ total, value, onChange }) => (
  <fieldset data-testid="plan-picker">
    <legend className="font-semibold mb-2">How would you like to pay?</legend>
    <div className="grid grid-cols-2 gap-3">
      {OPTIONS.map((n) => {
        const parts = splitPlan(total, n);
        const active = value === n;
        return (
          <button type="button" key={n} data-testid={`plan-option-${n}`} onClick={() => onChange(n)}
            className={`text-left rounded-2xl border-2 border-[var(--ink)] p-3 sm:p-4 transition-colors ${active ? "bg-[var(--lime)] shadow-[4px_4px_0_#14101F]" : "bg-white hover:bg-[var(--paper)]"}`}>
            <span className="block font-bold">{n === 1 ? "Pay in full" : `${n} weekly payments`}</span>
            <span className="block font-mono-x text-sm mt-0.5">{n === 1 ? money(total) : `${money(parts[0])} now, then weekly`}</span>
          </button>
        );
      })}
    </div>
    {value > 1 && (
      <p className="text-sm mt-3 text-[#3b3550]" data-testid="plan-note">
        No interest or fees. Your items are printed once the full amount has been paid.
      </p>
    )}
  </fieldset>
);
